"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.CardElement = void 0;
var _styledComponents = require("styled-components");
var _mediaQuery = _interopRequireDefault(require("../../utils/mediaQuery"));
var _borders = require("./borders");
const CardElement = (0, _styledComponents.css)(["", ";"], ({
  theme,
  expanded
}) => (0, _styledComponents.css)(["width:100%;box-sizing:border-box;position:relative;box-shadow:", ";border-top:", ";background:", ";", ";"], expanded && theme.orbit.boxShadowActionActive, !expanded && _borders.getBorder, theme.orbit.backgroundCard, _mediaQuery.default.largeMobile((0, _styledComponents.css)(["border-left:", ";border-right:", ";"], !expanded && _borders.getBorder, !expanded && _borders.getBorder))));
exports.CardElement = CardElement;